import { lazy } from 'react';
import { Images, ImagePlus } from 'lucide-react';
import type { Album, Photo } from '@app/shared';
import type { SearchResult, WebModule } from '../../app/types.ts';
import { familyRecords, scoreText } from '../../platform/search.ts';

export const photosModule: WebModule = {
  id: 'photos',
  label: 'Photos',
  icon: Images,
  path: '/photos',
  nav: { group: 'family', order: 10 },
  routes: [
    { path: 'photos', lazy: async () => ({ Component: (await import('./AlbumsScreen.tsx')).AlbumsScreen }) },
    { path: 'photos/:albumId', lazy: async () => ({ Component: (await import('./AlbumScreen.tsx')).AlbumScreen }) },
  ],
  home: [{ id: 'photos', title: 'Recent photos', order: 70, component: lazy(() => import('./home.tsx').then((m) => ({ default: m.RecentPhotos }))) }],
  quickActions: [{ id: 'album', label: 'Album', icon: ImagePlus, to: '/photos?add=1' }],
  async search(q, ctx) {
    const out: SearchResult[] = [];
    const albums = await familyRecords<Album>('albums', ctx.familyId);
    const titles = new Map(albums.map((a) => [a.id, a.title]));
    for (const a of albums) {
      const score = scoreText(q, [a.title, a.description]);
      if (score) out.push({ key: `albums:${a.id}`, title: a.title, subtitle: 'Album', to: `/photos/${a.id}`, group: 'Photos', icon: Images, score });
    }
    for (const p of await familyRecords<Photo>('photos', ctx.familyId)) {
      const score = p.caption ? scoreText(q, [p.caption]) : 0;
      if (score)
        out.push({
          key: `photos:${p.id}`,
          title: p.caption,
          subtitle: `Photo in ${titles.get(p.albumId) ?? 'an album'}`,
          to: `/photos/${p.albumId}?photo=${p.id}`,
          group: 'Photos',
          icon: Images,
          score,
        });
    }
    return out;
  },
};
